/**
 * Rune mesh data exports
 *
 * Re-exports all rune variants and types for easy importing.
 */

;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
export * from "./types.js";

import { AIR_MESHES, AIR_MATERIALS } from "./air.js";
import { ASTRAL_MESHES, ASTRAL_MATERIALS } from "./astral.js";
import { BLOOD_MESHES, BLOOD_MATERIALS } from "./blood.js";
import { BODY_MESHES, BODY_MATERIALS } from "./body.js";
import { CHAOS_MESHES, CHAOS_MATERIALS } from "./chaos.js";
import { COSMIC_MESHES, COSMIC_MATERIALS } from "./cosmic.js";
import { DEATH_MESHES, DEATH_MATERIALS } from "./death.js";
import { DUST_MESHES, DUST_MATERIALS } from "./dust.js";
import { EARTH_MESHES, EARTH_MATERIALS } from "./earth.js";
import { FIRE_MESHES, FIRE_MATERIALS } from "./fire.js";
import { LAVA_MESHES, LAVA_MATERIALS } from "./lava.js";
import { LAW_MESHES, LAW_MATERIALS } from "./law.js";
import { MIND_MESHES, MIND_MATERIALS } from "./mind.js";
import { MIST_MESHES, MIST_MATERIALS } from "./mist.js";
import { MUD_MESHES, MUD_MATERIALS } from "./mud.js";
import { NATURE_MESHES, NATURE_MATERIALS } from "./nature.js";
import { SMOKE_MESHES, SMOKE_MATERIALS } from "./smoke.js";
import { SOUL_MESHES, SOUL_MATERIALS } from "./soul.js";
import { STEAM_MESHES, STEAM_MATERIALS } from "./steam.js";
import { WATER_MESHES, WATER_MATERIALS } from "./water.js";
import { WRATH_MESHES, WRATH_MATERIALS } from "./wrath.js";
import type { RuneMaterials, RuneMesh, RuneVariant } from "./types.js";

/**
 * Get mesh data for a specific rune variant
 */
export function getRuneMeshes(variant: RuneVariant): RuneMesh[] {
  switch (variant) {
    case "air":
      return AIR_MESHES;
    case "astral":
      return ASTRAL_MESHES;
    case "blood":
      return BLOOD_MESHES;
    case "body":
      return BODY_MESHES;
    case "chaos":
      return CHAOS_MESHES;
    case "cosmic":
      return COSMIC_MESHES;
    case "death":
      return DEATH_MESHES;
    case "dust":
      return DUST_MESHES;
    case "earth":
      return EARTH_MESHES;
    case "fire":
      return FIRE_MESHES;
    case "lava":
      return LAVA_MESHES;
    case "law":
      return LAW_MESHES;
    case "mind":
      return MIND_MESHES;
    case "mist":
      return MIST_MESHES;
    case "mud":
      return MUD_MESHES;
    case "nature":
      return NATURE_MESHES;
    case "smoke":
      return SMOKE_MESHES;
    case "soul":
      return SOUL_MESHES;
    case "steam":
      return STEAM_MESHES;
    case "water":
      return WATER_MESHES;
    case "wrath":
      return WRATH_MESHES;
  }
}

/**
 * Get materials for a specific rune variant
 */
export function getRuneMaterials(variant: RuneVariant): RuneMaterials {
  switch (variant) {
    case "air":
      return AIR_MATERIALS;
    case "astral":
      return ASTRAL_MATERIALS;
    case "blood":
      return BLOOD_MATERIALS;
    case "body":
      return BODY_MATERIALS;
    case "chaos":
      return CHAOS_MATERIALS;
    case "cosmic":
      return COSMIC_MATERIALS;
    case "death":
      return DEATH_MATERIALS;
    case "dust":
      return DUST_MATERIALS;
    case "earth":
      return EARTH_MATERIALS;
    case "fire":
      return FIRE_MATERIALS;
    case "lava":
      return LAVA_MATERIALS;
    case "law":
      return LAW_MATERIALS;
    case "mind":
      return MIND_MATERIALS;
    case "mist":
      return MIST_MATERIALS;
    case "mud":
      return MUD_MATERIALS;
    case "nature":
      return NATURE_MATERIALS;
    case "smoke":
      return SMOKE_MATERIALS;
    case "soul":
      return SOUL_MATERIALS;
    case "steam":
      return STEAM_MATERIALS;
    case "water":
      return WATER_MATERIALS;
    case "wrath":
      return WRATH_MATERIALS;
  }
}
